import { render } from "./RevealPassword.vue?vue&type=template&id=5df695c1&ts=true"
import script from "./RevealPassword.vue?vue&type=script&lang=ts"
export * from "./RevealPassword.vue?vue&type=script&lang=ts"

import exportComponent from "/root/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__